import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { SalesOfficeTypeDropdownComponent }         from '../../components/DomainData/SalesOfficeTypeDropdown.component';
import { SalesOfficeDropdownComponent }         from '../../components/DomainData/SalesOfficeDropdown.component';
import {StateDropdownComponent} from '../../components/DomainData/StateDropdown.component';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-salesoffice-edit',
  templateUrl: './SalesOfficeEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => SalesOfficeEditComponent)}]
})
export class SalesOfficeEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    form: FormGroup;

    @ViewChild(SalesOfficeTypeDropdownComponent) public salesOfficeTypeDropdownComponent: SalesOfficeTypeDropdownComponent;    
    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdownComponent: SalesOfficeDropdownComponent;    
    @ViewChild(StateDropdownComponent) public stateDropdownComponent: StateDropdownComponent;

    @Input() public record: ent.SalesOffice;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
            'salesOfficeType' : '',
            'name' : '',
            'number' : '',
            'salesOrg' : '',
            'crossDockSalesOffice' : '',
            'aml' : '',
            'fountainPlanningPlant' : '',
            'coolerAndVendorPlanningPlant' : '',
            'calendarCode' : '',
            'inactive' : '',
            'enhancedPaymentOptions': '',
            'offDayDeliveryFee': '',
            'crossDockOverride': '',
            'streetNumber': '',
            'streetName': '',
            'city': '',
            'postalCode': '',
            'state': '',
            'latitude': '',
            'longitude': '',
            'taxCode': '',
            'county': '',
            'mapRefID': ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        
    }

    stateChange(event: any){
        this.record.StateID = event;
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    salesOfficeTypeChange(event: any){
        
        this.record.SalesOfficeTypeID = event;
    }

    crossDockSalesOfficeChange(event: any){
        
        this.record.CrossDockSalesOfficeID = event;
    }
    
}